import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';

@Injectable({ providedIn: 'root' })
export class IntegrationsGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);

  canActivate(): boolean {
    this.routeGuardService.handleRoute(this.getView());
    return true;
  }
  getView(): View {
    return {
      route: 'integrations',
      iframeUrl: 'integrations',
    };
  }
}
